export default __webpack_public_path__ + "static/media/meslay4.a5b0eb28.jpg";